import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { useFeedbackStore } from '@/stores/feedback';
import { useOnlineStore } from '@/stores/online';

//Create axios instance
const api = axios.create();

//Setup interceptor to add token to header whenever token is aquired
api.interceptors.request.use((config) => {
    //Set loading to true
    if (!(config as any).noFeedback) {
        useFeedbackStore().isLoading = true;
    }

    //Set authentication token in header if available
    const authStore = useAuthStore();
    const token = authStore.servicesToken;

    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    if (token) {
        config.headers.Authorization = 'Basic ' + token;
    }
    //Set x-requested-with header when calling the same origin to avoid login prompt
    if (config.url && window.location.origin == (new URL(config.url)).origin) {
        config.headers['x-requested-with'] = 'XMLHttpRequest';
    }
    return config;
},
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use((response) => {
    // Set feedbackStore.isLoading to false when a response is received
    const feedbackStore = useFeedbackStore();
    feedbackStore.isLoading = false;
    
    // Return the response data
    return response;
  }, (error) => {
    // Set feedbackStore.isLoading to false when an error response is received
    const feedbackStore = useFeedbackStore();
    const onlineStore = useOnlineStore();
    feedbackStore.isLoading = false;
  
    // Check for specific error conditions
    if (error.response) {
        // The request was made, and the server responded with a status code that's in the 500 range
        if (error.response.status.toString().startsWith('5')) {
            feedbackStore.setTranslatedMessage('danger', 'basicError');
        }

    // The request was made, but no response was received or the user has no connection
    } else if (error.request && !onlineStore.sentNoConnectionMessage) {
        feedbackStore.setTranslatedMessage('danger', 'noConnectionError', 3000);
        onlineStore.sentNoConnectionMessage = true;
    }
    
    // Return the error response
    return Promise.reject(error);
  });

export default api;